import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Tooltip } from "antd";
import classnames from "classnames";
import { longTextClass, rootClass } from "./constant.js";
import "./styles.css";
import { placements } from "./placements.js";
const tooltip_Tooltip = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { longText, rootClassName, builtinPlacements = placements, ...restProps } = props;
    return /*#__PURE__*/ jsx(Tooltip, {
        ref: ref,
        ...restProps,
        rootClassName: classnames(rootClass, longText && longTextClass, rootClassName),
        builtinPlacements: builtinPlacements
    });
});
export { tooltip_Tooltip as Tooltip };
